import { colors } from '@material-ui/core';

const white = '#FFFFFF';

export default {
  primary: {
    contrastText: white,
    dark: '#181b29',
    main: '#262b42',
    light: '#394163'
  },
  secondary: {
    contrastText: white,
    dark: '#b18f4e',
    main: '#E0B563',
    light: '#eec169'
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
    white: white,
  },
  link: colors.blue[800],
  icon: '#434b7a',
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
